// extracted by mini-css-extract-plugin
export default {"modalOverlay":"InstructionModal_modalOverlay__oJS4I","modalContent":"InstructionModal_modalContent__2bfI3"};